/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateActivityDto
 */
export interface CreateActivityDto {
    /**
     * Name of the activity
     * @type {string}
     * @memberof CreateActivityDto
     */
    'name': string;
    /**
     * Description of the activity
     * @type {string}
     * @memberof CreateActivityDto
     */
    'description'?: string;
    /**
     * External source ID for the activity
     * @type {string}
     * @memberof CreateActivityDto
     */
    'sourceId'?: string;
    /**
     * External source external ID for the activity
     * @type {string}
     * @memberof CreateActivityDto
     */
    'sourceExternalId'?: string;
    /**
     * Source of the activity
     * @type {string}
     * @memberof CreateActivityDto
     */
    'source': CreateActivityDtoSourceEnum;
    /**
     * Distance covered in meters
     * @type {number}
     * @memberof CreateActivityDto
     */
    'distance': number;
    /**
     * Duration of activity in seconds
     * @type {number}
     * @memberof CreateActivityDto
     */
    'duration': number;
    /**
     * Type of activity
     * @type {string}
     * @memberof CreateActivityDto
     */
    'type': CreateActivityDtoTypeEnum;
    /**
     * ActivityDate date in UTC
     * @type {string}
     * @memberof CreateActivityDto
     */
    'activityDate': string;
    /**
     * Array of image URLs associated with this activity
     * @type {Array<string>}
     * @memberof CreateActivityDto
     */
    'imageUrls'?: Array<string>;
    /**
     * Activity ID (optional for manual entry)
     * @type {string}
     * @memberof CreateActivityDto
     */
    'id'?: string;
}

export const CreateActivityDtoSourceEnum = {
    Strava: 'strava',
    Garmin: 'garmin',
    Manual: 'manual',
    AppleHealth: 'apple_health'
} as const;

export type CreateActivityDtoSourceEnum = typeof CreateActivityDtoSourceEnum[keyof typeof CreateActivityDtoSourceEnum];
export const CreateActivityDtoTypeEnum = {
    Run: 'run',
    Bike: 'bike',
    Swim: 'swim'
} as const;

export type CreateActivityDtoTypeEnum = typeof CreateActivityDtoTypeEnum[keyof typeof CreateActivityDtoTypeEnum];


